import api from './api';

const BASE = '/nabl-support';

const nablSupportService = {
  syncTickets: () => api.post(`${BASE}/sync`, {}, { timeout: 300000 }),
  getStats: () => api.get(`${BASE}/stats`),
  getTickets: (params) => api.get(`${BASE}/tickets`, { params: { ...params, excludeClosed: params.excludeClosed ?? false } }),
  getTicketThreads: (ticketNumber) => api.get(`${BASE}/tickets/${ticketNumber}/threads`),
  updateTicketStatus: (ticketNumber, status, correctiveAction, correctiveActionTaken) => api.patch(`${BASE}/tickets/${ticketNumber}/status`, { status, correctiveAction, correctiveActionTaken }),
  getUsers: () => api.get(`${BASE}/users`),
  getAllAssignments: () => api.get(`${BASE}/assignments`),
  getTicketAssignments: (ticketNumber) => api.get(`${BASE}/tickets/${ticketNumber}/assignments`),
  assignTicket: (ticketNumber, userIds) => api.post(`${BASE}/tickets/${ticketNumber}/assign`, { userIds }),
  updateTicketType: (ticketNumber, ticketType) => api.patch(`${BASE}/tickets/${ticketNumber}/type`, { ticketType }),
  exportTickets: () => api.get(`${BASE}/export`),
  aiRephrase: (text, mode) => api.post(`${BASE}/ai/rephrase`, { text, mode }),
  aiChat: (messages) => api.post(`${BASE}/ai/chat`, { messages }),
  getAnalytics: () => api.get(`${BASE}/analytics`),
  bulkUpdateStatus: (ticketNumbers, status) => api.patch(`${BASE}/tickets/bulk-status`, { ticketNumbers, status }),
  saveNote: (ticketNumber, note) => api.patch(`${BASE}/tickets/${ticketNumber}/note`, { note }),
  getAttachment: (messageId, attachmentId, filename, mimeType) =>
    api.get(`${BASE}/attachment`, { params: { messageId, attachmentId, filename, mimeType }, responseType: 'blob' }),
  replyEmail: (ticketNumber, payload) => api.post(`${BASE}/tickets/${ticketNumber}/reply`, payload),
  deleteTicket: (ticketNumber) => api.delete(`${BASE}/tickets/${ticketNumber}`),
  markAsRead: (ticketNumber) => api.patch(`${BASE}/tickets/${ticketNumber}/read`),
};

export default nablSupportService;
